import { env } from "../../../env";
const axios = require("axios").default;

const URL_ORI = `${env.REACT_APP_API_URL}`;

export const getMovement = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Movement/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createMovement = (payload) => {
  return axios.post(`${URL_ORI}/api/Movement`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getIdMovement = (id) => {
  return axios
    .get(`${URL_ORI}/api/Movement/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateMovement = (payload) => {
  return axios.put(`${URL_ORI}/api/Movement`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updateMovementStartWorkFlow = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Movement/StartWorkFlow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateMovementSetStatus = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Movement/setstatus`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateMovementCancel = (payload) => {
  return axios.put(`${URL_ORI}/api/Movement/Cancel`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const updateMovementConfirm = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Movement/Confirm`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateMovementAmmend = (payload) => {
  return axios.put(`${URL_ORI}/api/Movement/ammend`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};


export const updateMovementComplete = (payload) => {
  return axios.put(`${URL_ORI}/api/Movement/complete`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};


export const deleteMovement = (payload) => {
  return axios.delete(`${URL_ORI}/api/Movement`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const createMovementVehicles = (payload) => {
  return axios
    .post(`${URL_ORI}/api/Movement/addVehicles`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const deleteMovementVehicles = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/Movement/deleteVehicles`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const createMovementParties = (payload) => {
  return axios
    .post(`${URL_ORI}/api/Movement/addParties`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const uploadMovement = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(
      `${URL_ORI}/api/Movement/UploadMovementVehicle?object_id=${id}`,
      formData
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const uploadMovementWorkflow = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(
      `${URL_ORI}/api/Movement/UploadMovementWorkFlow?object_id=${id}`,
      formData
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const uploadPicking = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(
      `${URL_ORI}/api/Movement/UploadPickingMovement?object_id=${id}`,
      formData
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const uploadBTS = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(
      `${URL_ORI}/api/Movement/UploadBackToStorageMovement?object_id=${id}`,
      formData
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// Vehicle

export const getVehicle = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Movement/SearchVehiclesinMovement`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const createVehicle = (payload) => {
  return axios
    .post(`${URL_ORI}/api/Movement/AddVehicles`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateVehicle = (payload) => {
  return axios.put(`${URL_ORI}/api/Vehicle`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const deleteVehicle = (payload) => {
  return axios.delete(`${URL_ORI}/api/Vehicle`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

// party
export const getparty = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Movement/searchpartyInMovement`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const createParty = (payload) => {
  return axios
    .post(`${URL_ORI}/api/Movement/AddParties`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateParty = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Movement/UpdateParty`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const deleteParty = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/Movement/deleteParties`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// Generate Excel
export const getGenerateExcelBlob = (payload) => {
  return axios
    .post(
      `${URL_ORI}/api/RDM/GenerateExcel`,
      payload,
      {
        responseType: 'blob',
      }
    )
    .catch((error) => {
      if (error.response) {
        console.log(error.response, "eerorr");

        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
